import { CampaignListItem } from 'modules/campaigns/types/CampaignListItem';

export const updateCampaignGroupParent = ({
  campaignGroupId,
  campaigns,
  isNestedCampaignNeedsReview,
  isParentExpanded
}: {
  campaignGroupId: string;
  campaigns: CampaignListItem[];
  isNestedCampaignNeedsReview: boolean;
  isParentExpanded: boolean;
}): CampaignListItem[] => {
  const updatedCampaigns = campaigns.map((campaign) => {
    if (campaign.campaignGroupId === campaignGroupId && campaign.isParent) {
      return {
        ...campaign,
        isNestedCampaignNeedsReview,
        isParentExpanded
      };
    }

    return campaign;
  });

  return updatedCampaigns;
};
